module.exports = __webpack_public_path__ + "img/FREED FROM DESIGNER.aa8ddd5f.png";